export default __webpack_public_path__ + "static/media/SelectDestinationLitoralNorte.c84f3144.svg";